const modalStyles = {
  overlay: {
    zIndex: '1',
    backgroundColor: 'rgba(0, 0, 0, 0.4)',
  },
  content: {
    top: '25%',
    bottom: 'auto',
    background: '#fff',
    borderRadius: '10px',
    margin: 'auto',
    maxWidth: '400px',
    outline: 'none',
    padding: '30px',
  },
};

export default modalStyles;
